import { useState } from "react";
import { audioReel } from "@/mocks/evidence";

const wave = [6, 12, 9, 16, 11, 18, 8, 14, 10, 20, 13, 9, 17, 12, 7, 15, 10, 19, 11, 8, 14, 9, 16, 12];

export default function AudioReel() {
  const [playing, setPlaying] = useState<string | null>(null);

  return (
    <section id="audio" className="scroll-mt-24 border-y border-background-200 bg-background-100/70 py-10 md:py-12">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="flex items-center gap-2 font-display text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              <i className="ri-disc-line text-primary-500" />
              录音曝光 · 原声区
            </h2>
            <p className="mt-1 text-[13px] text-foreground-500">降噪转写 + 片段定位 · 关键数字与文档交叉核对</p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <span className="live-dot h-2 w-2 rounded-full bg-primary-500" />
            正在收集中 · {audioReel.length} 段
          </span>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {audioReel.map((a) => {
            const on = playing === a.id;
            return (
              <div
                key={a.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-start gap-3">
                    <button
                      type="button"
                      aria-label={on ? "暂停" : "播放"}
                      onClick={() => setPlaying(on ? null : a.id)}
                      className={`mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-lg text-background-50 transition-colors ${
                        on ? "bg-foreground-950" : "bg-primary-500 hover:bg-primary-600"
                      }`}
                    >
                      <i className={on ? "ri-pause-fill" : "ri-play-fill"} />
                    </button>
                    <div>
                      <h3 className="font-display text-base font-bold text-foreground-950">{a.title}</h3>
                      <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
                        <span>{a.duration}</span>
                        <span className="h-1 w-1 rounded-full bg-background-300" />
                        <span>{a.source}</span>
                        <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 font-medium text-secondary-900">
                          {a.level}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 波形 */}
                <div className={`mt-4 flex h-12 items-center gap-0.5 overflow-hidden rounded-md bg-background-100 px-3 ${on ? "" : "opacity-80"}`}>
                  {wave.map((h, i) => (
                    <span
                      key={i}
                      className={`flex-1 rounded-full transition-all ${
                        on ? "animate-pulse bg-primary-500" : "bg-background-300"
                      }`}
                      style={{ height: `${on ? Math.max(h, 20) : 6}px` }}
                    />
                  ))}
                </div>

                <p className="mt-3 text-[13px] leading-6 text-foreground-600">{a.description}</p>
                <div className="mt-3 flex flex-wrap items-center gap-2 border-t border-dashed border-background-200 pt-3">
                  {a.marks.map((m) => (
                    <span key={m} className="flex items-center gap-1 text-[11px] font-medium text-primary-600">
                      <i className="ri-verified-badge-fill text-accent-500" />
                      {m}
                    </span>
                  ))}
                  <span className="ml-auto flex items-center gap-1 text-[11px] text-foreground-400">
                    <i className="ri-arrow-right-s-line" />
                    看转写稿
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}